import React, { useEffect } from 'react';

function HubspotForm({ formId = 'da63a1b7-3916-4288-a244-120de7cb8d4b' }) {
  useEffect(() => {
    const initHubspotForm = async () => {
      // @ts-ignore
      if (window.hbspt) {
        // @ts-ignore
        await window.hbspt.forms.create({
          region: 'eu1',
          portalId: '25382908',
          formId,
          target: '#hubspotForm',
        });
      } else {
        setTimeout(() => {
          initHubspotForm();
        }, 500);
      }
    };
    initHubspotForm();
  }, [formId]);

  return <div id="hubspotForm"></div>;
}

export default HubspotForm;
